export default "__VITE_ASSET__CPbOiinv__"